(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define("shopifyintegration", ["react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["shopifyintegration"] = factory(require("react"), require("react-dom"));
	else
		root["shopifyintegration"] = factory(root["React"], root["ReactDOM"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__57__) {
return 